import { useEffect, useRef, useState } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

import { Toast } from '../ds/Toast.js';

// Medido no leitor-jwpub: abrir e fechar a PWA instalada não busca sw.js.
// Sem update() explícito o aparelho fica preso na versão instalada.
const INTERVALO_VERIFICACAO = 5 * 60 * 1000;
const INTERVALO_OCIOSO = 10 * 1000;

function ocioso(): boolean {
  return document.querySelector('dialog[open]') === null;
}

export function AtualizacaoDisponivel() {
  const registro = useRef<ServiceWorkerRegistration | null>(null);
  const [escondida, setEscondida] = useState(false);
  const [podeMostrar, setPodeMostrar] = useState(ocioso);
  const {
    needRefresh: [precisaAtualizar],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_url, r) {
      registro.current = r ?? null;
      void registro.current?.update();
    },
  });

  useEffect(() => {
    const verificar = () => {
      if (document.visibilityState === 'visible')
        void registro.current?.update();
    };
    document.addEventListener('visibilitychange', verificar);
    const relogio = setInterval(verificar, INTERVALO_VERIFICACAO);
    return () => {
      document.removeEventListener('visibilitychange', verificar);
      clearInterval(relogio);
    };
  }, []);

  useEffect(() => {
    if (!precisaAtualizar) return;
    const r = setInterval(() => setPodeMostrar(ocioso()), INTERVALO_OCIOSO);
    return () => clearInterval(r);
  }, [precisaAtualizar]);

  // O `Toast` monta o contêiner sempre, vazio: um `role="status"` que entra no
  // DOM já com conteúdo não é anunciado pelo leitor de tela.
  //
  // `segundos={0}` desliga a contagem de propósito: um aviso de atualização
  // não é a confirmação de algo que a pessoa acabou de fazer, é um convite
  // que ela precisa ter tempo de ler — e quem tem baixa visão lê devagar.
  // Ele sai da tela quando ela atualizar ou dispensar, não antes.
  return (
    <Toast
      mensagem={
        precisaAtualizar && podeMostrar && !escondida
          ? 'Nova versão disponível'
          : null
      }
      acao={{
        rotulo: 'Atualizar',
        aoAcionar: () => void updateServiceWorker(true),
      }}
      aoDispensar={() => setEscondida(true)}
      segundos={0}
    />
  );
}
